import { render, staticRenderFns } from "./ApprovalProcess.vue?vue&type=template&id=0647ee4e&scoped=true&"
import script from "./ApprovalProcess.vue?vue&type=script&lang=js&"
export * from "./ApprovalProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0647ee4e",
  null
  
)

export default component.exports